module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d03-6dc46e38cb24d3a6f93ea0a6a254b3fa.jpg";